import { render, staticRenderFns } from "./TimeSlotEvent.vue?vue&type=template&id=d4e65dbe&scoped=true&"
import script from "./TimeSlotEvent.vue?vue&type=script&lang=js&"
export * from "./TimeSlotEvent.vue?vue&type=script&lang=js&"
import style0 from "./TimeSlotEvent.vue?vue&type=style&index=0&id=d4e65dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e65dbe",
  null
  
)

export default component.exports